import "@/App.css";
import { BrowserRouter, Routes, Route, Navigate } from "react-router-dom";
import AppLayout from "@/layout/AppLayout";
import Dashboard from "@/pages/Dashboard";
import ComingSoon from "@/pages/ComingSoon";
import LeadIntake from "@/pages/LeadIntake";
import SequenceBuilder from "@/pages/SequenceBuilder";
import VoiceAgent from "@/pages/VoiceAgent";
import EmailSms from "@/pages/EmailSms";
import Pipeline from "@/pages/Pipeline";
import Orchestration from "@/pages/Orchestration";
import GrowthIntel from "@/pages/GrowthIntel";
import VelocityEngine from "@/pages/VelocityEngine";
import { NAV_ITEMS } from "@/nav/navConfig";
import { DemoProvider } from "@/demo/DemoContext";
import { WorkspaceProvider } from "@/nav/WorkspaceContext";

const CUSTOM_PAGES = {
  "/lead-intake": <LeadIntake />,
  "/sequence-builder": <SequenceBuilder />,
  "/voice-agent": <VoiceAgent />,
  "/email-sms": <EmailSms />,
  "/pipeline": <Pipeline />,
  "/orchestration": <Orchestration />,
  "/growth-intel": <GrowthIntel />,
  "/velocity-engine": <VelocityEngine />,
};

function App() {
  return (
    <div className="App">
      <BrowserRouter>
        <WorkspaceProvider>
          <DemoProvider>
            <Routes>
              <Route element={<AppLayout />}>
                <Route path="/" element={<Dashboard />} />
                {NAV_ITEMS.filter((n) => n.path !== "/").map((n) => (
                  <Route
                    key={n.path}
                    path={n.path}
                    element={
                      CUSTOM_PAGES[n.path] || (
                        <ComingSoon title={n.label} description={n.description} />
                      )
                    }
                  />
                ))}
                <Route path="*" element={<Navigate to="/" replace />} />
              </Route>
            </Routes>
          </DemoProvider>
        </WorkspaceProvider>
      </BrowserRouter>
    </div>
  );
}

export default App;
